// Minimal fetch wrapper for the registration API. The standalone registration
// blade does not load the legacy global `window.axios`, so this app talks to
// the backend with the native fetch API.
//
// The backend wraps successful payloads as { data: ... } (ApiTrait::respondData)
// or returns bare objects (respondOk). On error it returns a non-2xx status
// with { message } / { errors } (Laravel validation) or { flash }. We normalize
// both shapes so callers can rely on { status, message, errors }.

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return (window.__registrationCsrf || (meta && meta.getAttribute('content')) || '');
}

// Per-tab basket token, threaded as a query param on every request so the
// server resolves this tab's isolated basket (see registration.module.js).
let basketToken = null;

async function request(method, url, { params, body } = {}) {
  const finalUrl = new URL(url, window.location.origin);

  const allParams = { ...(params || {}) };
  // Send it on every request; an explicit basket_token in `params` wins.
  if (basketToken && allParams.basket_token === undefined) {
    allParams.basket_token = basketToken;
  }

  Object.entries(allParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      finalUrl.searchParams.set(key, value);
    }
  });

  const headers = {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': csrfToken(),
  };

  const options = {
    method,
    headers,
    credentials: 'same-origin',
  };

  if (body !== undefined) {
    headers['Content-Type'] = 'application/json';
    options.body = JSON.stringify(body);
  }

  const response = await fetch(finalUrl.toString(), options);

  let json = null;
  try {
    json = await response.json();
  } catch (e) {
    json = null;
  }

  if (!response.ok) {
    const error = new Error(
      (json && (json.message || json.flash)) || `Request failed (${response.status})`
    );
    error.status = response.status;
    error.errors = (json && json.errors) || {};
    error.payload = json;
    throw error;
  }

  // Unwrap respondData envelope; fall back to the raw body for respondOk.
  return json && Object.prototype.hasOwnProperty.call(json, 'data') ? json.data : json;
}

export const http = {
  setCsrf: (token) => { window.__registrationCsrf = token; },
  setBasketToken: (token) => { basketToken = token || null; },
  get: (url, params) => request('GET', url, { params }),
  post: (url, body) => request('POST', url, { body }),
  put: (url, body) => request('PUT', url, { body }),
  delete: (url, body) => request('DELETE', url, { body }),
};

export default http;
